import React, { useEffect, useRef, useState } from 'react';
import { FontWeightEnum, TextVariantColorEnum } from '@app/common';
import { getFakeString } from '../../../../utils/get-fake-string';
import { getLockedProps, getValueClassName } from '../utils/value-style';

type ValueStringCommonProps = {
    mode?: 'styled' | 'pure';
    text: string;
    locked?: boolean;
    inParentheses?: boolean;
};

type ValueStringStyledProps = {
    mode: 'styled';
    fontWeight?: FontWeightEnum;
    color?: TextVariantColorEnum;
};

type ValueStringPureProps = {
    mode?: 'pure';
};

type ValueString = ValueStringCommonProps & (ValueStringStyledProps | ValueStringPureProps);

export const ValueString: React.FC<ValueString> = (props) => {
    const lockedRef = useRef<HTMLSpanElement>(null);
    const [blur, setBlur] = useState<number>(0.3);
    const [value, setValue] = useState<string>('');

    const { text, locked = false, inParentheses = false } = props;

    const mode = props.mode ?? 'styled';

    useEffect(() => {
        const fakeText = getFakeString(text);
        const valueBefore = locked ? fakeText : text;
        setValue(inParentheses ? `(${valueBefore})` : valueBefore);

        if (lockedRef.current) {
            const fontSizeValue = parseFloat(window.getComputedStyle(lockedRef.current).fontSize);
            const blurSize = fontSizeValue / 50;
            const roundedBlurSize = parseFloat(blurSize.toFixed(2));
            setBlur(roundedBlurSize);
        }
    }, [text]);

    if (mode === 'styled') {
        const { color = TextVariantColorEnum.Default, fontWeight = FontWeightEnum.Medium } =
            props as ValueStringStyledProps;

        return (
            <span className={getValueClassName(color, fontWeight)}>
                <span ref={lockedRef} {...getLockedProps(locked, blur)}>
                    {value}
                </span>
            </span>
        );
    }

    return locked ? (
        <span ref={lockedRef} {...getLockedProps(true, blur)}>
            {value}
        </span>
    ) : (
        <>{value}</>
    );
};
